import Sitemap from './Sitemap';

export const sitemap = {
  firstLevel: Sitemap,
};